import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/topseller.webp'
import _imports_1 from '../../assets/topseller@2x.webp'
import _imports_2 from '../../assets/topseller@3x.webp'
import _imports_3 from '../../assets/checkmark_green.svg'


const _withScopeId = n => (_pushScopeId("data-v-53de56dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_1 + ', ' + _imports_2
const _hoisted_2 = { class: "my-0" }
const _hoisted_3 = {
  key: 0,
  class: "topseller-badge",
  src: _imports_0,
  alt: "topseller badge",
  srcset: _hoisted_1
}
const _hoisted_4 = {
  key: 1,
  class: "my-6 ml-0 items-baseline text-primary"
}
const _hoisted_5 = { class: "text-6xl" }
const _hoisted_6 = { class: "text-3xl" }
const _hoisted_7 = { class: "text-font" }
const _hoisted_8 = { class: "mb-8" }
const _hoisted_9 = {
  key: 0,
  class: "flex"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "checkmark mr-standard ml-0",
  src: _imports_3
}, null, -1))
const _hoisted_11 = { class: "my-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonControl = _resolveComponent("ButtonControl")!
  const _component_pulse_loader = _resolveComponent("pulse-loader")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: _normalizeClass(["pcard rounded-lg relative max-w-full", [
      _ctx.__elementcolorsclass ? _ctx.__elementcolorsclass : 'bg-background-accent',
      $setup.loadedProduct.topseller ? 'highlighted' : ''
    ]]),
    __elementspacingclass: _ctx.__elementspacingclass
  }, {
    default: _withCtx(() => [
      _createElementVNode("h3", _hoisted_2, _toDisplayString($setup.loadedProduct.name), 1),
      ($setup.loadedProduct.topseller)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      (!$props.hideprice)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString($setup.splitPrice[0]), 1),
            _createElementVNode("span", _hoisted_6, "." + _toDisplayString($setup.splitPrice[1] ? $setup.splitPrice[1] : "00"), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString($setup.loadedProduct.currency ? ` ${$setup.loadedProduct.currency}` : "") + " " + _toDisplayString($setup.paymentIntervalString), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.loadedProduct.feature_descriptions, (description, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: $setup.loadedProduct.id + 'feature' + index
          }, [
            description
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(description), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      (!$setup.loading)
        ? (_openBlock(), _createBlock(_component_ButtonControl, {
            key: 2,
            label: $setup.checkComplete ? 'BESTELLEN' : 'ADRESSE PRÜFEN',
            class: "max-w-full mx-auto",
            width: "316px",
            disabled: $setup.checkComplete && !$setup.available,
            highlighted: $setup.loadedProduct.topseller,
            onClick: $setup.onProductSelected
          }, null, 8, ["label", "disabled", "highlighted", "onClick"]))
        : (_openBlock(), _createBlock(_component_pulse_loader, {
            key: 3,
            class: "confirm flex justify-center",
            loading: $setup.loading,
            color: "#ea3d00"
          }, null, 8, ["loading"]))
    ]),
    _: 1
  }, 8, ["class", "__elementspacingclass"]))
}